"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountFilter = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Select_1 = require("../../../components/Select");
var ClearIndicator_1 = require("../misc/ClearIndicator");
var Wrapper_1 = require("./Wrapper");
var useFilter_1 = require("./useFilter");
var Row_1 = require("../../../components/Row");
var Clickable_1 = require("../../../components/Clickable");
//@ts-ignore
var componentStyles = function (_a) {
  var isClearable = _a.isClearable;
  return isClearable ? {
    clearIndicator: ClearIndicator_1.ClearIndicatorStyles
  } : {};
};
var AccountFilter = function (_a) {
  var _b;
  var label = _a.label,
    filterId = _a.id,
    placeholder = _a.placeholder,
    options = _a.options,
    _c = _a.defaultOptions,
    defaultOptions = _c === void 0 ? [] : _c,
    _d = _a.startExpanded,
    startExpanded = _d === void 0 ? false : _d,
    tooltip = _a.tooltip,
    tooltipIcon = _a.tooltipIcon,
    tooltipColor = _a.tooltipColor,
    tooltipIconColor = _a.tooltipIconColor,
    _e = _a.single,
    single = _e === void 0 ? false : _e;
  var _f = (0, useFilter_1.useFilter)({
      filterId: filterId,
      defaultMode: "include",
      defaultOptions: defaultOptions
    }),
    optionsSelected = _f.optionsSelected,
    setSelected = _f.setSelected,
    isActive = _f.isActive,
    isUnsaved = _f.isUnsaved,
    translation = _f.translation;
  return (0, jsx_runtime_1.jsxs)(Wrapper_1.FilterWrapper, __assign({
    tooltip: tooltip,
    tooltipIcon: tooltipIcon,
    tooltipColor: tooltipColor,
    tooltipIconColor: tooltipIconColor,
    filterId: filterId,
    label: label,
    isActive: isActive,
    isUnsaved: isUnsaved,
    mode: "include",
    selectedCount: (_b = optionsSelected === null || optionsSelected === void 0 ? void 0 : optionsSelected.length) !== null && _b !== void 0 ? _b : 0,
    startExpanded: startExpanded,
    isAccountFilter: true
  }, {
    children: [(0, jsx_runtime_1.jsx)("div", __assign({
      className: "select-filter multiSelect"
    }, {
      children: (0, jsx_runtime_1.jsx)(Select_1.Select, {
        components: {
          DropdownIndicator: function (_) {
            return null;
          },
          IndicatorSeparator: function (_) {
            return null;
          }
        },
        isClearable: true,
        isMulti: !single,
        closeMenuOnSelect: false,
        onChange: function (newValue) {
          if (newValue === void 0) {
            newValue = [];
          }
          return setSelected(newValue);
        },
        options: options,
        value: optionsSelected !== null && optionsSelected !== void 0 ? optionsSelected : [],
        placeholder: placeholder,
        //@ts-ignore
        style: {
          height: "auto"
        },
        styles: componentStyles({
          isClearable: true
        })
      })
    })), (0, jsx_runtime_1.jsxs)(Row_1.Row, __assign({
      gap: "large",
      justify: "start"
    }, {
      children: [(0, jsx_runtime_1.jsx)(Clickable_1.Clickable, __assign({
        onClick: function () {
          return setSelected(options);
        }
      }, {
        children: translation.selectAll
      })), (0, jsx_runtime_1.jsx)(Clickable_1.Clickable, __assign({
        onClick: function () {
          return setSelected([]);
        }
      }, {
        children: translation.deselectAll
      }))]
    }))]
  }));
};
exports.AccountFilter = AccountFilter;